<template>
  <FlotoCrudContainer
    ref="list"
    :fetch-fn="getAuditItems"
    :scrollable="false"
    :resource-name="$t('audit_trail')"
    :as-table="true"
  >
    <template v-slot:add-controls="{ refreshList }">
      <MRow class="items-center" :gutter="0">
        <div class="flex flex-1 items-center">
          <FlotoForm
            ref="formRef"
            class="flex items-center"
            @submit="refreshList"
          >
            <MCol auto-size class="pr-2">
              <FlotoFormItem
                id="from-picker"
                :label="$t('from')"
                :rules="{
                  // eslint-disable-next-line
                  max_date: endDate,
                }"
              >
                <FlotoDatePicker
                  v-model="startDate"
                  :allow-clear="false"
                  :max-date="endDate"
                />
              </FlotoFormItem>
            </MCol>
            <MCol auto-size class="px-2">
              <FlotoFormItem
                id="to-picker"
                :rules="{
                  // eslint-disable-next-line
                  min_date: startDate,
                }"
                :label="$t('to')"
              >
                <FlotoDatePicker
                  v-model="endDate"
                  :allow-clear="false"
                  :min-date="startDate"
                />
              </FlotoFormItem>
            </MCol>
            <template v-slot:submit>
              <span />
            </template>
          </FlotoForm>

          <MButton id="search-btn" class="mt-2 ml-3" @click="submitForm">
            {{ $t('search') }}
          </MButton>
        </div>
        <MDivider />
      </MRow>
    </template>
    <template v-slot:list-items="{ items }">
      <div>
        <MRow>
          <MCol class="my-2">
            <MTimeline mode="left" class="pl-2">
              <Audit
                v-for="timeline in items"
                :key="timeline.id"
                :parent-id="resourceId"
                icon="map-marker-alt"
                module-name="asset_geo_location_history"
                v-bind="timeline"
              />
            </MTimeline>
          </MCol>
        </MRow>
      </div>
    </template>
  </FlotoCrudContainer>
</template>

<script>
import Moment from 'moment'
import Audit from '@components/audit/audit'
import { getGeolocationHistory } from '../asset-api'
export default {
  name: 'GeolocationHistory',
  components: {
    Audit,
  },
  props: {
    moduleName: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    resourceId: { type: Number, default: undefined },
  },
  data() {
    return {
      searchLoading: false,
      startDate: Moment().subtract(6, 'months').startOf('day').unix() * 1000,
      endDate: Moment().endOf('day').unix() * 1000,
    }
  },
  methods: {
    submitForm() {
      if (this.searchLoading) {
        return
      }
      this.$refs.formRef.submit()
    },
    getAuditItems(limit, offset) {
      this.searchLoading = true
      const dataFilter = {
        startDate: this.startDate,
        endDate: this.endDate,
      }
      return getGeolocationHistory(
        this.resourceId,
        dataFilter,
        limit,
        offset
      ).finally(() => (this.searchLoading = false))
    },
    refresh() {
      this.$refs.list.refresh()
    },
  },
}
</script>
